export default {
  orders: null,
  orderDetail: null
}
